/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '~/lib/api/axiosClient';
import type {
  CancelMutationResponse,
  CancelPathParams,
  Cancel401,
} from '../../types/Cancel.ts';
import type { RequestConfig, ResponseErrorConfig } from '~/lib/api/axiosClient';

function getCancelUrl(jobId: CancelPathParams['jobId']) {
  const res = {
    method: 'POST',
    url: `/managed-jobs/${jobId}/cancelar` as const,
  };
  return res;
}

/**
 * {@link /managed-jobs/:jobId/cancelar}
 */
export async function cancel(
  jobId: CancelPathParams['jobId'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    CancelMutationResponse,
    ResponseErrorConfig<Cancel401>,
    unknown
  >({
    method: 'POST',
    url: getCancelUrl(jobId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
